import React from 'react';
import { Box } from '@mui/material';
import { ConfirmationDeleteProps } from './ConfirmationDelete.props';
import { CircleContainer, StyledDeleteIcon } from './ConfirmationDelete.styles';

const ConfirmationDelete = ({ itemName, customMessage }: ConfirmationDeleteProps) => {
  const getMessage = () => {
    if (customMessage) {
      return customMessage;
    }
    return `Are you sure you want to delete this ${itemName}?`;
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <CircleContainer>
        <StyledDeleteIcon fontSize="large" />
      </CircleContainer>
      <p>{getMessage()}</p>
    </Box>
  );
};

export default ConfirmationDelete;
